import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ButtonComponent from '../ButtonComponent/ButtonComponent'

import './AjaxButtonComponent.scss'

const renderContent = (opt) => {
  const { state, children, loadingText, successText } = opt

  if (state === 'idle') {
    return children
  }

  if (state === 'loading') {
    return (
      <div className="loading-state">
        <div className="spinner-container">
          <div className="spinner" />
        </div>
        <div>{loadingText}</div>
      </div>
    )
  }

  if (state === 'success') {
    return successText
  }

  if (state === 'failure') {
    return 'Retry'
  }

  return null
}

const getPropsForButtonState = (state, color, outlined) => {
  switch (state) {
    case 'success':
      return {
        disabled: true,
        iconConfig: {
          name: 'check',
          color: outlined ? '1AB451' : 'fff',
          size: [16, 16],
        },
      }
    case 'loading':
      return {
        disabled: true,
        iconConfig: {},
      }
    case 'failure':
      return {
        color: 'red',
        iconConfig: {
          name: 'error',
          color: outlined ? 'FA4646' : 'fff',
          size: [16, 16],
        },
      }
    default:
      return {}
  }
}

const AjaxButtonComponent = (props) => {
  const { color, state, className, outlined, size } = props
  const buttonProps = getPropsForButtonState(state, color, outlined)
  const classname = classnames('ajax-button-component', {
    [className]: className,
    [`is-${state}`]: state,
    [`color-${color}`]: color,
  })

  return (
    <ButtonComponent
      {...props}
      {...buttonProps}
      className={classname}
      size={size}
    >
      {renderContent(props)}
    </ButtonComponent>
  )
}

AjaxButtonComponent.propTypes = {
  state: PropTypes.oneOf(['idle', 'loading', 'success', 'failure']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  loadingText: PropTypes.string,
  successText: PropTypes.string,
  color: PropTypes.string,
  outlined: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'normal', 'large']),
}

AjaxButtonComponent.defaultProps = {
  state: 'idle',
  loadingText: 'Loading',
  successText: 'Success',
  size: 'normal',
}

export default AjaxButtonComponent
